import { useState } from 'react';
import { Flex, Text, IconButton, Icon, Blockquote } from '@scale/scaleui-radix';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { AuditRubric } from '@scale/shared-types';
import { RubricAnswers } from '../SpeedAudit/types';

const ChatBulkAuditCriteriaFeedbackSummary = ({
  rubric,
  rubricAnswers,
}: {
  rubric: AuditRubric;
  rubricAnswers: RubricAnswers;
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const criteriaToShow =
    rubric?.criteria.filter(criterion => rubricAnswers[criterion.id]?.justification) ?? [];
  return criteriaToShow.length === 0 ? (
    <Text color="neutral" className="italic">
      No criteria feedback provided.
    </Text>
  ) : (
    <>
      <Flex direction="row" gap="1" align="center">
        <Text color="neutral">See Criteria Feedback Summary</Text>
        <IconButton onClick={() => setCollapsed(!collapsed)} variant="ghost" color="neutral">
          <Icon
            size="1"
            icon={collapsed ? faChevronDown : faChevronUp}
            label={collapsed ? 'Expand' : 'Collapse'}
          />
        </IconButton>
      </Flex>
      {!collapsed && (
        <Blockquote>
          <Flex direction="column" gap="2">
            {criteriaToShow.map(criterion => (
              <Text key={criterion.id} className="italic">
                <Text as="span" weight="medium" color="neutral">
                  {criterion.title}:{' '}
                </Text>
                <Text as="span" color="neutral">
                  {rubricAnswers[criterion.id]?.justification}
                </Text>
              </Text>
            ))}
          </Flex>
        </Blockquote>
      )}
    </>
  );
};

export default ChatBulkAuditCriteriaFeedbackSummary;
